/* eslint-disable */
import MiniCart from './mini-cart.js';
import notice from '../components/notice';

const AjaxCart = {
  init() {
    let _this = this;
    jQuery(function ($) {
      $(document.body).on('wc_fragments_refreshed', function () {});
      _this.ListenAddToCart();
      _this.RemoveFromCart();
    });
  },
  AddToCart(thisObj) {
    let _this = this;
    if (typeof $ === 'undefined') {
      var $ = jQuery.noConflict();
    }

    var thisForm = thisObj.closest('form');
    var button = thisForm.find('.btn');
    var formUrl = thisForm.attr('action');
    var formMethod = thisForm.attr('method');
    if (typeof formMethod === 'undefined' || formMethod == '') {
      formMethod = 'POST';
    }

    const btnAttr = button.attr('name');

    var formData = new FormData(thisForm[0]);
    formData.append(btnAttr, button.val());

    button.addClass('loading');

    var CartAjaxTask = $.ajax({
      url: formUrl,
      method: formMethod,
      data: formData,
      cache: false,
      contentType: false,
      processData: false,
    })
      .done(function () {
        const el = document.getElementById('single-product-notice');
        if (el) el.style.display = 'block';

        $(document.body).trigger('wc_fragment_refresh');

        $.when(CartAjaxTask)
          .then(_this.UpdateCartWidget)
          .done(function () {
            if (btnAttr !== 'update_cart') {
              notice('Reservasjon lagt til i handlekurven', 'success'); // Reservation added to cart
              button.removeClass('loading');
            }

            $(document.body).trigger('added_to_cart');
          });
      })
      .fail(function () {
        button.removeClass('loading');

        if (btnAttr !== 'update_cart') {
          notice('Noe gikk galt under oppdatering av handlekurven', 'failure'); // Something went wrong while updating the shopping cart
        } else {
          notice(
            'Det var et problem med reservasjonen av bilen din', // There was a problem booking your car

            'failure'
          );
        }
      })
      .always(function () {
        $('.cart').off('submit');
        _this.ListenAddToCart();
      });
  },
  RemoveFromCart() {
    let _this = this;
    $(document).on('click', 'a.remove-from-mini-cart', function (e) {
      e.preventDefault();

      var product_id = $(this).attr('data-product_id'),
        cart_item_key = $(this).attr('data-cart_item_key');

      var CartAjaxTask = $.ajax({
        type: 'POST',
        dataType: 'json',
        url: window.woocommerce_params.ajax_url,
        data: {
          action: 'product_remove',
          product_id: product_id,
          cart_item_key: cart_item_key,
        },
      }).done(function () {
        $(document.body).trigger('wc_fragment_refresh');
        $.when(CartAjaxTask).then(_this.UpdateCartWidget);
      });
    });
  },

  ListenAddToCart() {
    let _this = this;
    $('form.cart').on('submit', function (e) {
      e.preventDefault();
      _this.AddToCart($(this));
    });
  },
  UpdateCartWidget() {
    var deferred = $.Deferred();

    $(document.body).on('wc_fragments_refreshed', function () {
      deferred.resolve();
      MiniCart.updateWidget();
    });

    return deferred.promise();
  },
};

export default AjaxCart;
